<template>
    <div class="z-1000">
        <!-- Social Media Section -->
        <div class="bg-black text-white py-2">
            <div class="container mx-auto flex justify-between items-center text-sm">
                <div>
                    <a href="tel:+8801308439359" class="mr-4 hover:text-gray-300">📞 +880 1308 439359</a>
                    <a href="mailto:bhawalsenaclub@gmail.com" class="hover:text-gray-300">✉️
                        bhawalsenaclub@gmail.com</a>
                </div>
                <div class="flex space-x-4">
                    <a href="https://youtube.com/@bhawalsenaclub" target="_blank" class="hover:text-gray-300">
                        <i class="fab fa-youtube"></i>
                    </a>
                    <a href="https://facebook.com/profile.php?id=61567809000093" target="_blank"
                        class="hover:text-gray-300">
                        <i class="fab fa-facebook"></i>
                    </a>
                    <a href="https://instagram.com/bhawal_sena_club" target="_blank" class="hover:text-gray-300">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://threads.net/@bhawal_sena_club" target="_blank" class="hover:text-gray-300">
                        <i class="fab fa-threads"></i>
                    </a>
                    <a href="https://twitter.com/bhawalsena_club" target="_blank" class="hover:text-gray-300">
                        <i class="fab fa-twitter"></i>
                    </a>
                </div>
            </div>
        </div>
        <nav class="bg-transparent p-4 text-dark border-b border-green-900">
            <div class="container mx-auto flex justify-between items-center">
                <!-- Logo -->
                <router-link to="/" class="flex items-center">
                    <img src="@/assets/bsclogo.png" alt="Bhawal Sena Club Logo" class="h-10 mr-2" />
                    <span class="text-xl font-bold hidden md:block">Bhawal Sena Club</span>
                </router-link>

                <!-- Mobile Menu Toggle Button -->
                <button class="md:hidden text-dark focus:outline-none" @click="toggleMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor" class="h-6 w-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>

                <!-- Menu -->
                <ul class="flex flex-col menu-mob md:flex-row md:space-x-4 absolute md:relative top-16 md:top-0 left-0 right-0 bg-white md:bg-transparent w-full md:w-auto p-4 md:p-0 transition-all duration-300"
                    :class="{ hidden: !isMenuOpen }">
                    <li>
                        <router-link to="/" class="hover:text-gray-800" :class="{ 'font-bold': $route.path === '/' }">
                            Home
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/about" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/about' }">
                            About Us
                        </router-link>
                    </li>
                    <!-- Dropdown Menu for Council -->
                    <li class="menu-item">
                        <button class="menu-button">
                            <span>Council</span>
                            <i class="fas fa-caret-down"></i>
                        </button>
                        <ul class="dropdown">
                            <li v-for="committee in committees" :key="committee.id" class="dropdown-item">
                                <router-link :to="`/council/${committee.slug}`">
                                    {{ committee.name_eng }}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <router-link to="/members" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/members' }">
                            Members
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/events" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/events' }">
                            Events
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/merge" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/merge' }">
                            Merge
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/blood-donation" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/blood-donation' }">
                            Blood Donation
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/gallery" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/gallery' }">
                            Gallery
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/contact" class="hover:text-gray-800"
                            :class="{ 'font-bold': $route.path === '/contact' }">
                            Contact
                        </router-link>
                    </li>
                </ul>

                <!-- Search Icon -->
                <button class="ml-4 text-dark focus:outline-none" @click="showSearch = true">
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </nav>

        <!-- Fullscreen Search Overlay -->
        <div v-if="showSearch" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div class="bg-white w-full max-w-lg p-6 rounded-lg relative">
                <button class="absolute top-0 right-0 text-white bg-red-600 rounded-lg p-2 m-0 hover:bg-gray-700"
                    @click="showSearch = false">
                    <i class="fas fa-times"></i>
                </button>
                <input type="text" placeholder="Search..."
                    class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            isMenuOpen: window.innerWidth >= 768,
            showSearch: false,
            committees: [], // Committees data
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        handleResize() {
            this.isMenuOpen = window.innerWidth >= 768;
        },
        fetchCommittees() {
            const BASE_URL = this.$root.$data.BASE_URL;
            axios
                .get(`${BASE_URL}/api/comittee/list`)
                .then((response) => {
                    this.committees = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching committees:', error);
                });
        },
    },
    mounted() {
        this.fetchCommittees();
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
@import "@fortawesome/fontawesome-free/css/all.css";

@media (max-width: 767px) {
    .menu-mob {
        z-index: 9999;
        margin-top: 30px;
    }
}

/* For the search input overlay */
.fixed {
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Parent list item */
.menu-item {
    position: relative;
}

/* Button styling */
.menu-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: inherit;
    font: inherit;
}

/* Dropdown menu */
.dropdown {
    position: absolute;
    top: 100%;
    /* Position below the button */
    left: 0;
    display: none;
    /* Hidden by default */
    background-color: white;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    padding: 0.5rem;
    white-space: nowrap;
    z-index: 1000;
}

/* Show dropdown on hover */
.menu-item:hover .dropdown {
    display: block;
    /* Change to flex for horizontal alignment */
    flex-direction: row;
    /* Arrange items in a single line */
}

/* Dropdown items */
.dropdown-item {
    margin: 0 0.5rem;
    /* Add horizontal spacing */
}

.dropdown-item a {
    text-decoration: none;
    color: black;
    padding: 0.5rem 1rem;
    display: block;
    transition: background-color 0.2s;
}

.dropdown-item a:hover {
    background-color: #f0f0f0;
    /* Highlight item on hover */
}
</style>
